import './App.scss';

import Container from './components/Container/Container';

function App() {
  return (
    <div className="App">
      <Container />
    </div>
  );
}

export default App;
